<div class="se-host" [ngClass]="currentEstensaTheme | async">
    <se-modaldialog-notifications> </se-modaldialog-notifications>

    <!-- FIRMA -->
    <se-sign-auth-dialog></se-sign-auth-dialog>
    <!-- firma multipla-->
    <se-multi-sign-auth-dialog></se-multi-sign-auth-dialog>
    <!-- Autenticazione -->
    <se-confirm-dialog></se-confirm-dialog>
    <!--  Auth multipla -->
    <se-multi-confirm-dialog></se-multi-confirm-dialog>

    <!-- OLD -->
    <div class="se-toolbar" *ngIf="!isVNext">
        <router-outlet name="toolbar"></router-outlet>
    </div>

    <se-header-information class="se-header-information" *ngIf="!isVNext"></se-header-information>
    <!-- OLD -->
    <!-- VNEXT -->
    @if (!isEmbedded()) {
    <mat-toolbar class="se-header-toolbar" *ngIf="isVNext">
        <mat-toolbar-row class="mat-elevation-z6 se-header-toolbar-container">
            <se-header-toolbar style="flex: 1 1 auto"> </se-header-toolbar>
        </mat-toolbar-row>
        <mat-toolbar-row class="se-buttons-toolbar-container">
            <router-outlet name="vnextToolbar"></router-outlet>
        </mat-toolbar-row>
    </mat-toolbar>

    <!-- VNEXT -->
    <!--TIMELINE-->
    <div *ngIf="isVNext && timelineOpen$ | async as timeline"
         [class.se-timeline-visible]="timeline.open"
         [class.se-timeline-hide]="!timeline.open">
        <se-timeline class="se-timeline" *ngIf="timeline.active"></se-timeline>
    </div>
    }
    <!--TIMELINE-->

    <div [class.se-content]="!isVNext" [class.vnext-content]="isVNext">
        <router-outlet></router-outlet>
        @if (!isEmbedded()) {
        <ng-container *ngIf="rightSlider$ | async as rightSlider">
            <div class="se-external-component-container"
                 [class.se-external-component-container-onenote]="rightSlider.isVisible && !rightSlider.isClosed"
                 [class.se-external-component-container-onenote-closed]="rightSlider.isClosed"
                 [class.se-external-component-container-overlap]="rightSlider.overlap"
                 [class.se-external-component-container-overlap-open]="rightSlider.overlapOpen">
                <se-side-nav></se-side-nav>
            </div>
        </ng-container>
        }
        <div class="estensa-spinner" *ngIf="isWaiting$ | async">
            <mat-spinner></mat-spinner>
        </div>
    </div>
</div>

<mat-icon style="position: absolute; right: 0; z-index: -1" fontSet="estensa-icons">icon_empty</mat-icon>

<ng-container *ngIf="pdfModalConfig$ | async as pdfModalConfig">
    <se-pdf-modal [sourceBase64]="pdfModalConfig.document"
                  [print]="pdfModalConfig.print"
                  [visible]="pdfModalConfig.visible"
                  (visibleChange)="onPdfModalVisiblityChange($event)"></se-pdf-modal>
</ng-container>

<se-external-docs-dialog></se-external-docs-dialog>

<toolupload-dialog></toolupload-dialog>
